export interface IDropdownOption {
  text: string;
  value: any;
}

export class DropdownOption<T> implements IDropdownOption {
  public readonly text: string;
  public readonly value: T;

  constructor(text: string, value: T) {
    this.text = text;
    this.value = value;
  }
}
